import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import Table from "MODULES/Admin/CompanyRankings/Table";

const StatsPanel = ({ label, title, results }) => {
  const style = {
    backgroundColor: "#928ff7",
    padding: "0 10px",
    borderRadius: "3px",
    boxShadow: "0 4px 4px rgba(0, 0, 0, 0.5)"
  };

  return (
    <Col md={6}>
      <div style={style}>
        <h2 style={{ lineHeight: "1.8", color: "hsla(0,0%,100%,0.8)" }}>
          {title}
        </h2>
      </div>
      <Table results={results} label={label} />
    </Col>
  );
};

export default StatsPanel;

StatsPanel.defaultProps = {
  report: "company",
  period: "all",
  title: null,
  config: { filters: () => ({}) }
};

StatsPanel.propTypes = {
  title: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({})),
  config: PropTypes.shape({
    filters: PropTypes.func.isRequired,
    request: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Admin/CompanyRankings/StatsPanel.jsx